import { IStruxTagActivitySessionsQuery } from '~/client/graph/operations/generated/StruxTagActivitySessions.generated'

export type Session = NonNullable<
  NonNullable<
    IStruxTagActivitySessionsQuery['struxTagActivitySessions']
  >[number]
>

export interface ISessionGroup {
  dayKey: number
  date: Date
  label: string
  totalDurationMs: number
  sessions: Session[]
}

export const MS_PER_HOUR = 60 * 60 * 1000
export const MS_PER_DAY = 24 * MS_PER_HOUR
export const STRIP_TICK_HOURS = [0, 6, 12, 18]
